import React from 'react';
import { CountdownBar } from '../components/artTherapy/CountdownBar';
import { Hero } from '../components/artTherapy/Hero';
import { StatsGrid } from '../components/artTherapy/StatsGrid';
import { PainPoints } from '../components/artTherapy/PainPoints';
import { AudienceFit } from '../components/artTherapy/AudienceFit';
import { FourSteps } from '../components/artTherapy/FourSteps';
import { ManualPages } from '../components/artTherapy/ManualPages';
import { Bundle } from '../components/artTherapy/Bundle';
import { PricingOffer } from '../components/artTherapy/PricingOffer';
import { Reviews } from '../components/artTherapy/Reviews';
import { GuaranteeSeal } from '../components/artTherapy/GuaranteeSeal';
import { FaqList } from '../components/artTherapy/FaqList';
import { ClosingCta } from '../components/artTherapy/ClosingCta';
import { SiteFooter } from '../components/artTherapy/SiteFooter';
export function Landing() {
  return <div className="min-h-screen w-full overflow-x-clip bg-cream font-sans text-ink" data-id="element-364" data-mp="m83iih9cprpb">
      <CountdownBar data-id="element-365" data-mp="2atjqns46bfw" />
      <main data-id="element-366" data-mp="2bbok8sudxzf">
        <Hero data-id="element-367" data-mp="27xoj77ni0v5" />
        <StatsGrid data-id="element-368" data-mp="3tgbhxu1ad6ud" />
        <PainPoints data-id="element-369" data-mp="3tftmv0qd0yo1" />
        <ManualPages data-id="element-370" data-mp="3tfjvp9tkwlgr" />
        <AudienceFit data-id="element-371" data-mp="3tf0e5u7ubz39" />
        <FourSteps data-id="element-372" data-mp="3tio4kkhzo5dr" />
        <Reviews data-id="element-373" data-mp="3pe82kubhxi3t" />
        <Bundle data-id="element-374" data-mp="3pfrjmn4z7x6n" />
        <PricingOffer data-id="element-375" data-mp="3pfj9h308n5z5" />
        <GuaranteeSeal data-id="element-376" data-mp="3pguaww67o1n3" />
        <FaqList data-id="element-377" data-mp="3kfwsqjl7b7ll" />
        <ClosingCta data-id="element-378" data-mp="3kgexy5pucw5n" />
      </main>
      <SiteFooter data-id="element-379" data-mp="3kh7y2nuaonet" />
    </div>;
}